module.exports = new __parcel__URL__("instagram.fd36ef2c.png").toString();